<template>
<div class="chapter">
<div class="inner_page">
<div id="toc"><h1 class="fronttitle paired">Contents</h1>
<hr/>
<p class="toc sub"><span href="#/titlepage" title="Link target outside of Sample">Title Page</span></p>
<p class="toc sub"><a href="#/contents">Contents</a></p>
<p class="toc sub"><a href="#/front01">Copyright</a></p>
<p class="toc sub"><a href="#/front02">Dedication</a></p>
<p class="toc sub"><a href="#/front03">Epigraph</a></p>
<p class="toc sub"><a href="#/front04">Prologue</a></p>
<p class="toc"><a href="#/c01">Liberation</a></p>
<p class="toc"><a href="#/c02">The Good Nazis</a></p>
<p class="toc"><span href="#/c03" title="Link target outside of Sample">“Minor War Crimes”</span></p>
<p class="toc"><span href="#/c04" title="Link target outside of Sample">Echoes from Argentina</span></p>
<p class="toc"><span href="#/c05" title="Link target outside of Sample">Tilting at Swastikas</span></p>
<p class="toc"><span href="#/c06" title="Link target outside of Sample">In the Pursuit of Science</span></p>
<p class="toc"><span href="#/c07" title="Link target outside of Sample">Out of the Shadows</span></p>
<p class="toc"><span href="#/c08" title="Link target outside of Sample">“An Ugly Blot”</span></p>
<p class="toc"><span href="#/c09" title="Link target outside of Sample">Photos</span></p>
<p class="toc"><span href="#/c10" title="Link target outside of Sample">The Sins of the Father</span></p>
<p class="toc"><span href="#/c11" title="Link target outside of Sample">A Good Party Spoiled</span></p>
<p class="toc"><span href="#/c12" title="Link target outside of Sample">“An Innocent Man”</span></p>
<p class="toc"><span href="#/c13" title="Link target outside of Sample">Backlash</span></p>
<p class="toc"><span href="#/c14" title="Link target outside of Sample">Ivan the Terrible</span></p>
<p class="toc"><span href="#/c15" title="Link target outside of Sample">The Road to Ponary</span></p>
<p class="toc sub"><span href="#/back01" title="Link target outside of Sample">Epilogue</span></p>
<p class="toc sub"><span href="#/back02" title="Link target outside of Sample">Map</span></p>
<p class="toc sub"><span href="#/back03" title="Link target outside of Sample">Acknowledgments</span></p>
<p class="toc sub"><span href="#/back04" title="Link target outside of Sample">Notes</span></p>
<p class="toc sub"><span href="#/back05" title="Link target outside of Sample">Index</span></p>
<p class="toc sub"><span href="#/back06" title="Link target outside of Sample">About the Author</span></p>
<p class="toc sub"><span href="#/back07" title="Link target outside of Sample">Connect with HMH</span></p></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?3cfd8c9c